// Lib
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from '../../../../../../../node_module_clones/recompose';

import imageSearchSelector from './imageSearchSelector';

// Actions
import { imageSearchPopupSubmit, imageSearchPopupSetMode } from './imageSearchPopupActions';

import { closePopup } from '../../../../../../components/popupPanel/popupActions';

// Components
import searchFormInputManager from '../../../../../../components/search/searchFormInputManager';

import PopupModeMenu from '../../../../../../components/popupPanel/types/modeMenu/PopupModeMenu';
import PopupModeContent from '../../../../../../components/popupPanel/types/modeContent/PopupModeContent';
import ImageSearchResultList from './ImageSearchResultList';
import ImagePopupUploadForm from './ImagePopupUploadForm';
import ToolbarPopup from '../../../toolbarPopup/ToolbarPopup';

import { IMAGE_SEARCH_POPUP_MODE_UPLOAD } from './imageSearchPopupConstants';
import { PEXELS_ATTRIBUTION_LINK } from '../../../../../../../common/images/imageConstants';

// Styles
import './ImageSearchPopup.scss';
import usePrevious from '../../../../../../utils/react/usePrevious';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';

const mapDispatchToProps = (dispatch) => ({
    setMode: ({ mode }) => dispatch(imageSearchPopupSetMode(mode)),
    submitSearch: (query) => dispatch(imageSearchPopupSetMode(query.toLowerCase())),
    searchForImages: (query, popupMode, offset) => dispatch(imageSearchPopupSubmit(query, popupMode, offset)),
    closeImagePopup: () => dispatch(closePopup(PopupIds.IMAGE)),
});

const enhance = compose(connect(imageSearchSelector, mapDispatchToProps), searchFormInputManager);

const ImageSearchPopupContainer = (props) => {
    const { searchForImages, searchResultsList, searchQuery, popupMode, closeImagePopup } = props;

    const prevQuery = usePrevious(searchQuery);

    useEffect(() => {
        if (
            searchResultsList.length === 0 &&
            popupMode !== IMAGE_SEARCH_POPUP_MODE_UPLOAD &&
            prevQuery !== searchQuery
        ) {
            searchForImages(searchQuery, popupMode, 0);
        }
    }, [searchResultsList, searchQuery, prevQuery]);

    const handleFetchMore = () => {
        searchForImages(searchQuery, popupMode, searchResultsList.length);
    };

    return (
        <div className="ImageSearchPopup">
            <PopupModeMenu
                {...props}
                showSearch
                searchPlaceholder="Search images..."
                tools={
                    <div className="attribution">
                        Over 3 million free images provided by&nbsp;
                        <a href={PEXELS_ATTRIBUTION_LINK} target="_blank" rel="noopener noreferrer nofollow">
                            Pexels
                        </a>
                    </div>
                }
            />
            <PopupModeContent>
                {popupMode === IMAGE_SEARCH_POPUP_MODE_UPLOAD ? (
                    <ImagePopupUploadForm {...props} uploadCallbackFn={closeImagePopup} />
                ) : (
                    <ImageSearchResultList {...props} handleFetchMore={handleFetchMore} />
                )}
            </PopupModeContent>
        </div>
    );
};

ImageSearchPopupContainer.propTypes = {
    popupMode: PropTypes.string,
    searchQuery: PropTypes.string,
    rootBoardId: PropTypes.string,
    results: PropTypes.object,
    resultsTotal: PropTypes.number,
    searchResultsList: PropTypes.array,
    loading: PropTypes.bool,
    focusedIndex: PropTypes.number,
    hasMoreResults: PropTypes.bool,
    defaultSearch: PropTypes.string,
    submittedSearchQuery: PropTypes.string,

    searchForImages: PropTypes.func,
    closeImagePopup: PropTypes.func,
    clearSearch: PropTypes.func,
    setQuery: PropTypes.func,
    navigateToSearchResult: PropTypes.func,
    loadMoreResults: PropTypes.func,
};

// NOTE: Writing the component this way ensures that the ImageSearchPopupContainer isn't mounted before
//  the popup is opened.
const ImageSearchPopup = (props) => (
    <ToolbarPopup
        {...props}
        popupId={PopupIds.IMAGE}
        buttonSelector=".popup-trigger-image .Icon"
        className="image-popup"
    >
        <ImageSearchPopupContainer {...props} />
    </ToolbarPopup>
);

export default enhance(ImageSearchPopup);
